import React from 'react';

import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import useRequest from '@common/react/hooks/useRequest';
import FormikField from '@common/react/components/Forms/FormikField/FormikField';
import ImageLazy from '@common/react/components/UI/ImageLazy/ImageLazy';

import {
	emailValidator,
	simpleStringFirstNameValidator,
	simpleStringMessageValidator,
	simpleStringValidator,
} from '@app/utils/validationHelpersForm';
import SubmitButton from '@app/components/UI/SubmitButton/SubmitButton';

interface EmailToMaryInquiry {
	name: string;
	lastName: string;
	email: string;
	text: string;
}

const initialValuesEmailToMaryInquiry: EmailToMaryInquiry = {
	name: '',
	lastName: '',
	email: '',
	text: '',
};

const EmailToMaryInquiry = Yup.object().shape({
	name: simpleStringFirstNameValidator,
	lastName: simpleStringValidator,
	email: emailValidator,
	text: simpleStringMessageValidator,
});

const EmailForm: React.FC<{ textDone: string; }> = ({ textDone }) => {
	const [message, setMessage] = React.useState('');
	const [error, setError] = React.useState('');
	const [loading, setLoading] = React.useState(false);
	const request = useRequest();

	const handleSubmitEmailInquiry = (values, formikHelpers) => {
		setError('');
		setMessage('');
		setLoading(true);

		request('emailToMary', values)
			.then((res) => {
				setTimeout(() => {
					setMessage('Successfully send.');
					formikHelpers.resetForm({ values: initialValuesEmailToMaryInquiry });
				}, 0);
				setTimeout(() => setMessage(''), 10000);
			})
			.catch((e) => {
				setError('Something went wrong');
				setTimeout(() => setLoading(false), 300);
				setTimeout(() => setError(''), 10000);
			})
			.finally(() => {
				setTimeout(() => setLoading(false), 300);
			});
	};

	return (
		<Formik<EmailToMaryInquiry>
			initialValues={initialValuesEmailToMaryInquiry}
			onSubmit={handleSubmitEmailInquiry}
			validationSchema={EmailToMaryInquiry}
		>
			{(formikBag) => {
				return <Form className="email-form">
					<div className="row">
						<FormikField
							title=""
							containerClassName="form-group col-sm-4"
							fieldName="name"
							inputProps={{
								placeholder: 'First Name',
							}}
						/>
						<FormikField
							title=""
							containerClassName="form-group col-sm-4"
							fieldName="lastName"
							inputProps={{
								placeholder: 'Last Name',
							}}
						/>
						<FormikField
							title=""
							containerClassName="form-group col-sm-4"
							fieldName="email"
							inputProps={{
								placeholder: 'Email',
							}}
						/>
					</div>
					<FormikField
						title=""
						containerClassName="form-group textarea-validation"
						fieldName="text"
						render={({ field, form }) => <div>
							<textarea
								{...field}
								placeholder="Message"
								className="form-control"
							/>
							<ImageLazy
								alt="cat"
								width={113}
								height={175}
								className="cat-pen"
								src="/images/CatPencil.png"
							/>
						</div>}
					/>
					<SubmitButton
						loading={loading}
						error={error}
						message={message}
						formikBag={formikBag}
						textButton="Send message"
						textDone={textDone}
					/>
				</Form>;
			}}
		</Formik>
	);
};

export default EmailForm;
